module.exports = __webpack_public_path__ + "img/img_joinstep_store.a58bc99b.svg";